// src/components/site-editor/UpgradeModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Sparkles, Check } from 'lucide-react';

const UpgradeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  const professionalFeatures = [
    'Beautiful website builder with customizable templates',
    'Unlimited services and bookings',
    'Client management tools',
    'Calendar integration',
    'Professional branding',
    'Analytics and insights'
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl max-w-lg w-full p-6 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <X className="w-5 h-5 text-slate-400" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center">
            <Sparkles className="w-8 h-8 text-white" />
          </div>
        </div>

        {/* Title */}
        <h3 className="text-2xl font-bold text-slate-900 text-center mb-2">
          Publishing your site requires a Pro or Elite plan
        </h3>

        {/* Description */}
        <p className="text-slate-600 text-center mb-6">
          Go live with your practice website, accept bookings, and start growing your business.
        </p>

        {/* Features List */}
        <div className="bg-purple-50 rounded-lg p-4 mb-6">
          <h4 className="text-sm font-semibold text-purple-900 mb-3">
            What's included in Professional:
          </h4>
          <ul className="space-y-2">
            {professionalFeatures.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-2 text-sm text-purple-800">
                <Check className="w-4 h-4 text-purple-600 mt-0.5 flex-shrink-0" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Pricing */}
        <div className="text-center mb-6">
          <div className="text-3xl font-bold text-slate-900 mb-1">
            $49<span className="text-lg text-slate-600 font-normal">/month</span>
          </div>
          <p className="text-sm text-slate-600">Full platform access, no transaction fees</p>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-medium"
          >
            Continue Editing
          </button>
          <button
            onClick={handleUpgrade}
            className="flex-1 px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium shadow-md hover:shadow-lg"
          >
            View Plans
          </button>
        </div>

        {/* Footer note */}
        <p className="text-xs text-slate-500 text-center mt-4">
          7-day free trial • Cancel anytime
        </p>
      </div>
    </div>
  );
};

export default UpgradeModal;
